import React, { FC, useState } from 'react';
import classNames from 'classnames';
import { MobileAccordionMenuItem } from '../mobile-accordion-menu-item/MobileAccordionMenuItem';
import styles from './MobileAccordionMenu.scss';

interface MobileAccordionMenuProps {
  items: MenuItem;
  setActiveLevel?: (level: number) => void;
  level?: number;
  hierarchy?: string[];
}

export const MobileAccordionMenu: FC<MobileAccordionMenuProps> = ({
  items,
  setActiveLevel = () => {},
  level = 0,
  hierarchy = [],
}) => {
  const [activeIndex, updateActiveIndex] = useState<number>(-1);
  const [closingIndex, setClosingIndex] = useState<number | null>(null);

  const onItemOpened = (index: number) => {
    if (activeIndex === index) {
      setClosingIndex(index);
    } else {
      setClosingIndex(null);
      updateActiveIndex(index);
    }
  };

  const onItemClick = (index: number) => {
    updateActiveIndex(index);
    setActiveLevel(level + 1);
  };

  const onNavigateBack = (index: number) => {
    setActiveLevel(level);
    updateActiveIndex(index);
  };

  const handleAnimationEnd = () => {
    updateActiveIndex(-1);
    setClosingIndex(null);
  };

  return (
    <div className={classNames(styles.mobileAccordionMenu)}>
      {items.child?.length > 0 && (
        <ul className={styles.mobileAccordionMenuList}>
          {items.child?.map((item, index) => (
            <MobileAccordionMenuItem
              key={item.id}
              item={item}
              index={index}
              isActive={activeIndex === index}
              isClosing={closingIndex === index}
              onItemClick={() => onItemClick(index)}
              onItemOpened={onItemOpened}
              onAnimationEnd={handleAnimationEnd}
              onNavigateBack={() => onNavigateBack(index)}
              hierarchy={hierarchy}
            ></MobileAccordionMenuItem>
          ))}
        </ul>
      )}
    </div>
  );
};
